function toSentenceCase(data) {
  return data.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}

function updateCategoryType(productType) {
  switch(productType) {
    case 'apparel':
      this.event.category = 'Customs - Apparel';
      break;
    case 'footwear':
      this.event.category = 'Customs - Footwear';
      break;
    case 'backpack':
      this.event.category = 'Customs - Backpack';
      break;
    default:
      this.event.category = productType;
  }
}

export { toSentenceCase, updateCategoryType };
